var React = require('react');

function GhostProLogo (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Slice"),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("rect",{"stroke":"#A4D037","fillRule":"nonzero","x":".5","y":"7.5","width":"35","height":"21","rx":"4","key":0}),React.createElement("path",{"d":"M7 21.976V14h2.92c1.114 0 2.059.976 2.059 2.476s-.945 2.278-2.059 2.278h-2.9M15 21.976V14h2.92c1.114 0 2.059.976 2.059 2.476s-.945 2.278-2.059 2.278h-2.9M18 19l1.979 3","stroke":"#A4D037","strokeLinecap":"round","strokeLinejoin":"round","fillRule":"nonzero","key":1}),React.createElement("ellipse",{"stroke":"#A4D037","strokeLinecap":"square","fillRule":"nonzero","cx":"26.479","cy":"18","rx":"3.5","ry":"4","key":2})])]);
}

GhostProLogo.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36"};

module.exports = GhostProLogo;

GhostProLogo.default = GhostProLogo;
